import React from 'react';
import { View } from 'react-native';
import Typography from '../../../components/Text/Text';
import Checkbox from '../../../components/Checkbox/Checkbox';
import Divider from '../../../components/Divider/Divider';
import SwitchSection from './SwitchSection';
import { styles } from '../screens/Policy/PolicyScreen.styles';

interface FilingsDetails {
  federal: boolean;
  state: boolean;
}

interface FilingsSectionProps {
  filings: {
    required: 'yes' | 'no' | null;
    setRequired: (value: 'yes' | 'no' | null) => void;
    details: FilingsDetails;
    setDetails: (details: (prev: FilingsDetails) => FilingsDetails) => void;
  };
}

const FilingsSection: React.FC<FilingsSectionProps> = ({ filings }) => {
  const handleFilingsChange = (type: 'federal' | 'state', checked: boolean) => {
    filings.setDetails((prev) => ({ ...prev, [type]: checked }));
  };

  const handleRequiredChange = (value: 'yes' | 'no') => {
    filings.setRequired(value);
    if (value === 'no') {
      // If 'No' is selected, reset both checkboxes to false
      filings.setDetails((prev) => ({
        ...prev,
        federal: false,
        state: false,
      }));
    } else {
      // If 'Yes' is selected, always set federal to true
      filings.setDetails((prev) => ({
        ...prev,
        federal: true,
      }));
    }
  };

  return (
    <SwitchSection<'yes' | 'no'>
      label="Do you require Federal or State Filings for Auto Liability?"
      parentTestID={'federal-state-filing'}
      value={filings.required}
      onChange={handleRequiredChange}
      buttons={[
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ]}
      childrenRenderCondition={(selectedValue) => selectedValue === 'yes'}>
      <View style={styles.checkboxContainer}>
        <Typography variant="title2" style={styles.label}>
          Please indicate if you require Federal or State Filings for Auto Liability Insurance.
        </Typography>
        <View style={styles.checkboxItem}>
          <Checkbox
            active={filings.details.federal}
            onChange={(checked) => handleFilingsChange('federal', checked)}
          />
          <Typography variant="body1">Federal Filings Required</Typography>
        </View>
        <Divider />
        <View style={styles.checkboxItem}>
          <Checkbox
            active={filings.details.state}
            onChange={(checked) => handleFilingsChange('state', checked)}
          />
          <Typography variant="body1">State Filings Required</Typography>
        </View>
        <Divider />
      </View>
    </SwitchSection>
  );
};

export default FilingsSection;
